import classnames from "classnames";
import { useEffect, useState } from "react";
import { Button } from "@heroui/react";

const wrapperClasses = (isOpen: boolean) => classnames({
  'px-2 py-0 border w-fit rounded-full cursor-pointer': true,
  'border-brick-primary bg-brick-primary text-white': isOpen,
  'border-brick-primary bg-white text-brick-primary': !isOpen,
});

interface ToggleProps {
  label: string;
  isActive: boolean;
  onClick: (label: string, isActive: boolean) => void;
}

export const Toggle = ({ label, isActive, onClick }: ToggleProps) => {
  const [active, setActive] = useState(isActive);

  // Effect to handle external updates to isActive
  useEffect(() => {
    setActive(isActive);
  }, [isActive]);

  const handleClick = () => {
    const newActiveState = !active;
    setActive(newActiveState);
    onClick(label, newActiveState);
  };

  return (
    <Button size='sm' className={wrapperClasses(active)} onClick={handleClick}>
      {label}
    </Button>
  );
};
